var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "feature-video" }, [
    _vm.isShowingVideo
      ? _c("div", { domProps: { innerHTML: _vm._s(_vm.embedCode) } })
      : _vm._e(),
    _vm._v(" "),
    !_vm.isShowingVideo
      ? _c(
          "button",
          {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy:background-image",
                value: _vm.posterFrame,
                expression: "posterFrame",
                arg: "background-image",
              },
            ],
            key: _vm.posterFrame,
            staticClass: "feature-video__poster-frame",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.didSelectShowVideo()
              },
            },
          },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Play Video")])]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/FeatureVideo.vue